import React from 'react';
import { toast } from 'react-toastify';
import { getUserMentorship } from '../../../../../../services/apiService';
import { AgGridReact } from 'ag-grid-react';

const pageSize = 10;

const Mentorship = ({ goalType, userId }) => {
  const [rowsData, setRowsData] = React.useState(null);
  React.useEffect(async () => {
    if (!userId) return;
    try {
      const data = await getUserMentorship(userId);
      setRowsData(data);
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  }, []);

  const defaultColDef = {
    filter: true,
    sortable: true,
    resizable: true,
    menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    headerComponentParams: {
      menuIcon: 'fa-bars',
      template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
    },
  };

  const columnDefs = [
    { field: 'moduleId', hide: true },
    { field: 'bookingId', headerName: 'Booking Id' },
    { field: 'sessionModule', headerName: 'Session Module' },
    { field: 'sessionWorkload', headerName: 'Session Work Load' },
    { field: 'sessionName', headerName: 'Session Name' },
    { field: 'sessionScore', headerName: 'Session Score' },
  ];

  return (
    <div>
      <div className='ag-theme-alpine h-96  w-full'>
        <AgGridReact
          //   className='ag-theme-alpine'
          //   animateRows='true'
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          //   enableRangeSelection='true'
          rowData={rowsData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          rowHeight={50}
        />
      </div>
    </div>
  );
};

export default Mentorship;
